import React from "react";
import { useState, useEffect } from "react";

import { ArrowRightCircle } from "react-bootstrap-icons";
import { Container } from "react-bootstrap";

import "./Home.scss";
import AnimatedLetters from "../../components/AnimatedLetters/AnimatedLetters";
import { Link } from "react-router-dom";

const Home = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(200);

  const toRotate = ["unior Web Developer", "unior Full-Stack Engineer", "unior Software Developer"];
  const period = 1000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
    // eslint-disable-next-line
  }, [text, delta]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(100);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(200);
    }
  };

  const greeting = [
    // '👋',
    'H',
    'i',
    ' ',
    ' ',
    't',
    'h',
    'e',
    'r',
    'e',
    ' ',
    ' ',
    'I',
    "'",
    'm',
    ' ',
    ' ',
    'D',
    'o',
    'r',
    'o',
    't',
    'a',
  ];


  return (
    <section className="banner" id="home">
      <Container>
        <div className="animate__animated animate__pulse">
          <span className="tagline">Welcome to my Portfolio</span>
          <br />
          <br />
          <h1>
          <AnimatedLetters
              strArray={greeting}
              idx={1}
          />
            <br/>
            <span className="wrap">J{text}</span>
          </h1>
          <p>
              I'm a very ambitious junior developer, looking for a role in an established IT company with the opportunity to work with the latest technologies on challenging and diverse projects. I have just finished a 12-week Software Development Bootcamp at _nology and I am currently furthering my knowledge with the help of post-course.
          </p>
          <br />
          <p>
              I'm quite confident, naturally curious, and perpetually working on learning new languages and technologies.
          </p>
          <Link to="/contact">
          <button>
            Let's Connect <ArrowRightCircle size={25} />{" "}
          </button>
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default Home;
